export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('policies', {
    mounted(el, { value }) {
      const { userPolicies } = useUserStore()
      if (!userPolicies?.[value]) el.style.display = 'none'
    },
  })
})
